import Text from '~/common/components/Texts/Text';

type AssetItem = {
  asset: { bankName?: string; assetType?: string; assetId?: string };
};

type AssetListType = AssetItem | AssetItem[];

export function DialogDeleteMessage({
  list,
}: Readonly<{ list: AssetListType }>) {
  const items = Array.isArray(list) ? list : [list];

  if (items.length === 1) {
    const { asset } = items[0];
    return (
      <Text fontWeight={'500'}>
        Are you sure you want to remove this asset:{' '}
        <strong>{asset.bankName ?? asset.assetType}</strong>?
      </Text>
    );
  }

  return (
    <div>
      <Text textAlign="start" fontWeight={'500'}>
        Are you sure you want to remove the selected assets?
      </Text>
      <ul>
        {items.map((item) => (
          <li key={item.asset.assetId}>
            {item.asset.bankName ?? item.asset.assetType}
          </li>
        ))}
      </ul>
    </div>
  );
}
